var Backbone = require('backbone');
var Marionette = require('marionette');
var MultiTab = require('MultiTab')
var Labels = EY.Consultation.Labels;
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;

var View = Marionette.View.extend({
    ui: {
        createDetail: '#createDetail'
    },
    template: '#recordDetail',
    onRender: function () {
        this.ui.createDetail.addClass(this.model.get('creatorGivenName') ? '' : 'hidden');
    }
});

module.exports.start = function (options) {
    var record = options.record;
    var region = options.region;
    var lockedBy = record.get('lockedBy');
    var isOpenedByCurrentUser = record.get('isOpenedByCurrentUser')

    var editedBy = lockedBy !== "" && lockedBy !== User.upn ? ' (' + Labels.EditedBy + ': ' + record.get('lockedByGivenName') + ') ' : '';
    MultiTab.isOpenedInMultiTab({isOpenedByCurrentUser}) && lockedBy === User.upn && (editedBy = Labels.EditedBySameUserMessage)

    region.show(new View({
        model: new Backbone.Model({
            number: record.get('shortId'),
            recordType: Labels[record.get('recordTypeId')],
            status: Labels[record.get('statusResourceKey')],
            reviewer: record.get('statusTypeId') == StatusType.Preparation ? ' (' + record.get('assignedToGivenName') + ') ' : '',
            creatorGivenName: record.get('creatorGivenName'),
            createdOn: record.get('statusTypeId') === StatusType.Blank ? '' : new Date(record.get('createdOn')).format(),
            editedBy: editedBy
        })
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordDetails.js